module.exports = __webpack_public_path__ + "static/bar_chart_5-9a10c00d989495fb24a1b7948131590f.png";